(function (module) {
    "use strict";
    module.service("dtpChartService", ["calculationPPGService", dtpChartService]);
    function dtpChartService(calculationPPGService: $TSFixMe) {
        function getPeriodLenghtInMonths(startDate: $TSFixMe, endDate: $TSFixMe) {
            var startDateMoment = moment(startDate);

            var endDateMoment = moment(endDate);
            return Math.floor(endDateMoment.diff(startDateMoment, "months", true) + 0.5) + 1;
        }

        function prepareData(data: $TSFixMe) {
            var historical: $TSFixMe = [],
                correct: $TSFixMe = [],
                result = [historical, correct];
            data.map(function (item: $TSFixMe) {
                item.data.map(function (e: $TSFixMe) {
                    if (e.historical || e.historical == null || e.historical === undefined || e.historical === 0) {
                        historical.push(e.historical);
                    }

                    if (e.correctData) {
                        correct.push(e.correctData);
                    } else {
                        correct.push(e.historical);
                    }
                });
            });
            return result;
        }

        function prepareValue(data: $TSFixMe) {
            var historicalValue: $TSFixMe = [],
                averageValue: $TSFixMe = [],
                result = [historicalValue, averageValue];

            data.map(function (item: $TSFixMe) {
                item.data.map(function (e: $TSFixMe) {
                    historicalValue.push(e.price);
                    averageValue.push(e.averagePrices);
                });
            });
            return result;
        }

        function prepareDataToTable(objResume: $TSFixMe, data: $TSFixMe, correctData: $TSFixMe) {
            var result: $TSFixMe[] = [];
            for (var a in objResume) {
                var obj: $TSFixMe = {
                    year: a
                };
                var dataHist = [];
                var dataToprepare = data.splice(0, objResume[a]);
                if (correctData) {
                    var dataCorrecttoprepare = correctData.splice(0, objResume[a]);
                    for (var i = 0, max = dataToprepare.length; i < max; i++) {
                        var historical = {
                            historical: dataToprepare[i],
                            correctData: dataCorrecttoprepare[i]
                        };
                        dataHist.push(historical);
                    }
                } else {
                    for (var i = 0, max = dataToprepare.length; i < max; i++) {
                        var historicalData = {
                            historical: dataToprepare[i]
                        };
                        dataHist.push(historicalData);
                    }
                }

                obj.data = dataHist;
                result.push(obj);
            }
            var firstElement = result[0].data,
                lastElement = result[result.length - 1].data;
            if (firstElement.length < 12) {
                var temp = new Array(12 - firstElement.length);
                var fullFirstElement = temp.concat(firstElement);
                result[0].data = fullFirstElement;
            }
            if (lastElement.length < 12) {
                var tmp = new Array(12 - lastElement.length);
                var fullLastElement = lastElement.concat(tmp);
                result[result.length - 1].data = fullLastElement;
            }
            return result;
        }

        function prepareDataToDeviationIMSFromRF(
            objResume: $TSFixMe,
            historicalIms: $TSFixMe,
            rollingForecast: $TSFixMe,
            deviation: $TSFixMe
        ) {
            type Result = { year: string; data?: { historicalIms: number; rf: number; deviation: number }[] };
            let result: Result[] = [];
            const copyImsData = historicalIms.slice(),
                copyDeviation = deviation.slice(),
                rfCopy = rollingForecast.slice();

            for (let a in objResume) {
                let obj: Result = {
                    year: a
                };
                let data = [];
                let historicalImsData = copyImsData.splice(0, objResume[a]),
                    rfData = rfCopy.splice(0, objResume[a]),
                    deviationData = copyDeviation.splice(0, objResume[a]);

                for (let i = 0, max = historicalImsData.length; i < max; i++) {
                    let itemData = {
                        historicalIms: historicalImsData[i],
                        rf: rfData[i],
                        deviation: deviationData[i]
                    };
                    data.push(itemData);
                }

                obj.data = data;
                result.push(obj);
            }
            let firstElement = result[0].data!,
                lastElement = result[result.length - 1].data!;
            if (firstElement.length < 12) {
                let temp = new Array(12 - firstElement.length);
                let fullFirstElement = temp.concat(firstElement);
                result[0].data = fullFirstElement;
            }
            if (lastElement.length < 12) {
                let tmp = new Array(12 - lastElement.length);
                let fullLastElement = lastElement.concat(tmp);
                result[result.length - 1].data = fullLastElement;
            }
            return result;
        }

        function preparePeriodsAndLabels(startDate: $TSFixMe, endDate: $TSFixMe) {
            var start = moment(startDate),
                end = moment(endDate),
                periods = [],
                labels = [],
                count = 1;

            while (end >= start || start.format("M") === end.format("M")) {
                labels.push(count);
                count += 1;
                periods.push(start.format("YYYY-MM"));
                start.add(1, "month");
            }
            return {
                labels: labels,
                periods: periods
            };
        }

        function countMonthWithData(arr: $TSFixMe) {
            return arr.reduce(function (prev: $TSFixMe, cur: $TSFixMe) {
                prev[cur.slice(0, 4)] = (prev[cur.slice(0, 4)] || 0) + 1;
                return prev;
            }, {});
        }

        function countMonth(obj: $TSFixMe) {
            var count = 0;
            for (var key in obj) {
                count += parseInt(obj[key]);
            }
            return count;
        }

        function prepareArray(arr: $TSFixMe, sumObj: $TSFixMe) {
            var index = countMonth(sumObj),
                newArr = arr.slice();
            return newArr.splice(arr.length - index, index);
        }

        function sumData(arr: $TSFixMe, name: $TSFixMe) {
            var sum = 0;
            arr.map(function (item: $TSFixMe) {
                sum += item && item[name] ? item[name] : 0;
            });
            return sum;
        }

        function sumCorrectData(arr: $TSFixMe, name: $TSFixMe) {
            var sum = 0;
            arr.map(function (item: $TSFixMe) {
                if (
                    item &&
                    typeof item.correctData === "object" &&
                    item.correctData !== undefined &&
                    item.correctData !== null &&
                    item.correctData.correct !== null &&
                    !isNaN(item.correctData.correct)
                ) {
                    sum += parseFloat(item.correctData.correct);
                } else {
                    if (item && item[name] !== null) {
                        sum += parseFloat(item[name]);
                    }
                }
            });
            return sum;
        }

        return {
            prepareData: prepareData,
            prepareValue: prepareValue,
            prepareDataToTable: prepareDataToTable,
            preparePeriodsAndLabels: preparePeriodsAndLabels,
            countMonthWithData: countMonthWithData,
            prepareArray: prepareArray,
            countMonth: countMonth,
            sumData: sumData,
            sumCorrectData: sumCorrectData,
            getPeriodLenghtInMonths: getPeriodLenghtInMonths,
            prepareDataToDeviationIMSFromRF: prepareDataToDeviationIMSFromRF
        };
    }
})(angular.module("topline.services"));
